const Loading = {
  functional: true,
  render(createElement, ctx) {
    return ctx.children;
  },
};

export default () => ({
  component: (async () => (await import('vue-transition-expand')).TransitionExpand)(),
  loading: Loading,
});
